export enum HowToEnum {
  'Donor Portal - Users' = 'rec0dfv6WoWV9Pbom',
  'Campaigns Tab' = 'recF9szkc8d5X5Uh9',
  'Donor Profile' = 'recIW1RL7quwt5wf0',
  'Community Portal - Saved' = 'recJaKrzLj4qt2mcA',
  'Community Portal  - Donors' = 'recSYEBr8eKHfNu3G',
  'Explore Available and Donated Items' = 'recX6fBJOmgVaLKq7',
  'Managing Available Plaques' = 'recXM5BqFP3BPZXKZ',
  'Donor Portal - Donated Items' = 'recYWBRPH3tWQI7Bm',
  'Community Stories Tab' = 'recZQd7V7zHNf1sJr',
  'Donor Portal - Saved' = 'recbwBBomjKD4eFmE',
  'Donor Portal - About' = 'recf3B9eLiQJDcHXO',
  'About Tab' = 'reciCrmE4BKuw1bRS',
  'Community Profile' = 'reclIWJLihp57Bi8t',
  'Managing Users' = 'recmAtgVgHhJOxqiQ',
  'Community Portal  - Donation Program' = 'reco5eBe1hLaoa2ah',
  'Managing Activity Log' = 'recrb3PMGuPzpVAZq',
  'Donor Portal - Communities' = 'recxc9qap4mkWUdxW',
  'Subscription Details' = '3797ee76-4776-4d6b-8cc2-26a42952d145',
  'Custom Forms' = '20308955-c26e-4b3d-964d-4c3b2e2cf84a',
}
